var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventsCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2141 13.8808L11.6783 17.4167C11.5236 17.5715 11.34 17.6942 11.1379 17.778C10.9358 17.8618 10.7191 17.9049 10.5003 17.9049C10.2815 17.9049 10.0649 17.8618 9.86279 17.778C9.66067 17.6942 9.47705 17.5715 9.32242 17.4167L5.78576 13.8808C4.85344 12.9485 4.21853 11.7606 3.96133 10.4674C3.70412 9.17419 3.83616 7.83376 4.34076 6.61561C4.84535 5.39745 5.69984 4.35628 6.79616 3.62376C7.89248 2.89123 9.18139 2.50024 10.4999 2.50024C11.8184 2.50024 13.1074 2.89123 14.2037 3.62376C15.3 4.35628 16.1545 5.39745 16.6591 6.61561C17.1637 7.83376 17.2957 9.17419 17.0385 10.4674C16.7813 11.7606 16.1464 12.9485 15.2141 13.8808V13.8808Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2678 10.9344C12.7366 10.4656 13 9.82971 13 9.16667C13 8.50363 12.7366 7.86774 12.2678 7.3989C11.7989 6.93006 11.163 6.66667 10.5 6.66667C9.83696 6.66667 9.20107 6.93006 8.73223 7.3989C8.26339 7.86774 8 8.50363 8 9.16667C8 9.82971 8.26339 10.4656 8.73223 10.9344C9.20107 11.4033 9.83696 11.6667 10.5 11.6667C11.163 11.6667 11.7989 11.4033 12.2678 10.9344Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsCount);
export default __webpack_public_path__ + "static/media/events-count.6ba77ade77eca8ac39e3b9ad5a58a550.svg";
export { ForwardRef as ReactComponent };